/* bek-product-media (2026-09-20, Claude) – Reveal, Tilt, Slider-Punkte, Lightbox (Bild + Video). Vanilla, keine Abhängigkeiten. */
(function () {
  'use strict';
  if (window.__bekPmLoaded) return;
  window.__bekPmLoaded = true;

  /* a11y: reduzierte Bewegung nur über html.bek-reduce-motion (setzt bek-a11y-head, auch bei Systemeinstellung) */
  var RM = { get matches() { return document.documentElement.classList.contains('bek-reduce-motion'); } };
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_L = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>';
  var ICON_ZOUT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M7.5 10.5h6"/></svg>';

  function sizedUrl(src, w) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---------- Scroll-Reveal ---------- */
  function reveal(root) {
    var els = root.querySelectorAll('.bek-pm__reveal');
    function done(el) {
      setTimeout(function () { el.classList.add('is-done'); el.style.transitionDelay = ''; }, 1100);
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in', 'is-done'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.style.transitionDelay = (RM.matches ? 0 : n * 80) + 'ms';
        n++;
        el.classList.add('is-in');
        io.unobserve(el);
        done(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3D-Tilt (max. 4°) ---------- */
  function tilt(root) {
    if (!FINE.matches || RM.matches || root.__bekPmTilt) return;
    root.__bekPmTilt = true;
    root.querySelectorAll('.bek-pm__tile').forEach(function (tile) {
      var inner = tile.querySelector('.bek-pm__tile-inner');
      if (!inner) return;
      var rect = null, raf = 0, rx = 0, ry = 0;
      tile.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        rect = tile.getBoundingClientRect();
        tile.classList.add('is-tilt');
      });
      tile.addEventListener('pointermove', function (e) {
        if (!rect || e.pointerType !== 'mouse') return;
        var px = (e.clientX - rect.left) / rect.width - 0.5;
        var py = (e.clientY - rect.top) / rect.height - 0.5;
        ry = Math.max(-4, Math.min(4, px * 8));
        rx = Math.max(-4, Math.min(4, -py * 8));
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          inner.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
        });
      });
      tile.addEventListener('pointerleave', function () {
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        rect = null;
        tile.classList.remove('is-tilt');
        inner.style.transform = '';
      });
    });
  }

  /* ---------- Slider-Punkte ---------- */
  function dots(root) {
    var track = root.querySelector('.bek-pm__tiles');
    var wrap = root.querySelector('.bek-pm__dots');
    if (!track || !wrap) return;
    var tiles = [].slice.call(track.querySelectorAll('.bek-pm__tile'));
    if (tiles.length < 2) { wrap.hidden = true; return; }
    var btns = tiles.map(function (t, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bek-pm__dot';
      b.setAttribute('aria-label', 'Zu Bild ' + (i + 1));
      b.addEventListener('click', function () {
        track.scrollTo({ left: t.offsetLeft, behavior: RM.matches ? 'auto' : 'smooth' });
      });
      wrap.appendChild(b);
      return b;
    });
    var raf = 0;
    function update() {
      raf = 0;
      var step = tiles[1].offsetLeft - tiles[0].offsetLeft || 1;
      var i = Math.round(track.scrollLeft / step);
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) i = tiles.length - 1;
      i = Math.max(0, Math.min(tiles.length - 1, i));
      btns.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }

  /* ---------- Pfeile (Bilderleiste) ---------- */
  function arrows(root) {
    var track = root.querySelector('.bek-pm__tiles');
    var prev = root.querySelector('[data-bek-pm-prev]');
    var next = root.querySelector('[data-bek-pm-next]');
    if (!track || (!prev && !next)) return;
    function step() {
      var t = track.querySelector('.bek-pm__tile');
      var w = t ? t.getBoundingClientRect().width : track.clientWidth * 0.5;
      return Math.round(w + 14);
    }
    function scrollBy(dir) {
      track.scrollBy({ left: dir * step(), behavior: RM.matches ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
    var raf = 0;
    function sync() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth - 2;
      var scrollable = max > 2;
      if (prev) prev.disabled = !scrollable || track.scrollLeft <= 2;
      if (next) next.disabled = !scrollable || track.scrollLeft >= max;
    }
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(sync); });
    sync();
  }

  /* ---------- Lightbox ---------- */
  var LB = (function () {
    var el, fig, img, cap, counter, prev, next, closeBtn, vbox, thumbs, resetBtn;
    var items = [], idx = 0, root = null, mode = null, lastFocus = null, closing = false, touch = null, closeTimer = 0;

    function build() {
      if (el) return;
      el = document.createElement('div');
      el.className = 'bek-pm-lb';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Bildansicht');
      el.hidden = true;
      el.innerHTML =
        '<div class="bek-pm-lb__backdrop" data-bek-pm-close></div>' +
        '<figure class="bek-pm-lb__figure"><img class="bek-pm-lb__img" alt="" decoding="async" draggable="false"><figcaption class="bek-pm-lb__cap"></figcaption></figure>' +
        '<div class="bek-pm-lb__video"></div>' +
        '<button type="button" class="bek-pm-lb__nav bek-pm-lb__nav--prev" aria-label="Vorheriges Bild">' + ICON_L + '</button>' +
        '<button type="button" class="bek-pm-lb__nav bek-pm-lb__nav--next" aria-label="Nächstes Bild">' + ICON_R + '</button>' +
        '<div class="bek-pm-lb__top"><span class="bek-pm-lb__counter" aria-live="polite"></span>' +
        '<span class="bek-pm-lb__tools">' +
        '<button type="button" class="bek-pm-lb__reset" aria-label="Zoom zurücksetzen">' + ICON_ZOUT + '</button>' +
        '<button type="button" class="bek-pm-lb__close" aria-label="Schließen" data-bek-pm-close>' + ICON_X + '</button></span></div>' +
        '<div class="bek-pm-lb__thumbs" role="group" aria-label="Bildauswahl"></div>'; /* a11y (Claude, 2026-09-28): kein tablist ohne tabs */
      document.body.appendChild(el);
      fig = el.querySelector('.bek-pm-lb__figure');
      img = el.querySelector('.bek-pm-lb__img');
      cap = el.querySelector('.bek-pm-lb__cap');
      counter = el.querySelector('.bek-pm-lb__counter');
      prev = el.querySelector('.bek-pm-lb__nav--prev');
      next = el.querySelector('.bek-pm-lb__nav--next');
      closeBtn = el.querySelector('.bek-pm-lb__close');
      vbox = el.querySelector('.bek-pm-lb__video');
      thumbs = el.querySelector('.bek-pm-lb__thumbs');
      resetBtn = el.querySelector('.bek-pm-lb__reset');

      el.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-bek-pm-close]')) { close(); return; }
        // Klick neben das Bild schließt, Klick auf Bild, Schalter oder Miniaturen nicht.
        if (t === img || t.closest('button') || t.closest('.bek-pm-lb__thumbs') || t.closest('.bek-pm-lb__video')) return;
        close();
      });
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      el.addEventListener('keydown', onKey);
      resetBtn.addEventListener('click', function () { setZoom(1, 0, 0, true); });
      bindZoom();
      window.addEventListener('resize', function () {
        if (el.hidden || mode !== 'image') return;
        place(layout(items[idx]));
        clampPan();
        applyZoom(false);
      });
    }

    function lock(on) {
      var html = document.documentElement;
      if (on) {
        if (html.classList.contains('bek-pm-lock')) return; /* schon gesperrt (Wiederöffnen beim Schließen): Scrollbreite behalten */
        html.style.setProperty('--bek-pm-sbw', (window.innerWidth - html.clientWidth) + 'px');
        html.classList.add('bek-pm-lock');
      } else {
        html.classList.remove('bek-pm-lock');
        html.style.removeProperty('--bek-pm-sbw');
      }
    }

    function focusables() {
      return [].slice.call(el.querySelectorAll('button, iframe')).filter(function (b) {
        return b.offsetParent !== null && !b.hidden;
      });
    }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (mode === 'image' && e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
      if (mode === 'image' && e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
      if (mode === 'image' && (e.key === '+' || e.key === '=')) { e.preventDefault(); zoomAt(window.innerWidth / 2, window.innerHeight / 2, zoom.s * 1.5, true); return; }
      if (mode === 'image' && e.key === '-') { e.preventDefault(); zoomAt(window.innerWidth / 2, window.innerHeight / 2, zoom.s / 1.5, true); return; }
      if (mode === 'image' && e.key === '0') { e.preventDefault(); setZoom(1, 0, 0, true); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (f.indexOf(document.activeElement) === -1) { e.preventDefault(); first.focus(); }
      }
    }

    /* ---------- Zoom: Rad, Klick, Ziehen, Pinch, Doppeltipp ---------- */
    var zoom = { s: 1, x: 0, y: 0, max: 4 };

    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    function clampPan() {
      var w = fig.offsetWidth, h = fig.offsetHeight;
      var mx = Math.max(0, (w * zoom.s - w) / 2);
      var my = Math.max(0, (h * zoom.s - h) / 2);
      zoom.x = clamp(zoom.x, -mx, mx);
      zoom.y = clamp(zoom.y, -my, my);
    }

    function applyZoom(anim) {
      if (!anim) img.style.transition = 'none';
      img.style.transform = zoom.s === 1 ? '' : 'translate(' + zoom.x.toFixed(1) + 'px,' + zoom.y.toFixed(1) + 'px) scale(' + zoom.s.toFixed(3) + ')';
      el.classList.toggle('is-zoomed', zoom.s > 1.01);
      if (!anim) { img.getBoundingClientRect(); img.style.transition = ''; }
      // Schärfe nachziehen: größere sizes lassen den Browser eine höhere Auflösung wählen.
      var vw = Math.min(400, Math.round((window.innerWidth < 590 ? 92 : 72) * zoom.s));
      img.sizes = vw + 'vw';
    }

    function setZoom(s, x, y, anim) {
      zoom.s = clamp(s, 1, zoom.max);
      zoom.x = zoom.s === 1 ? 0 : x;
      zoom.y = zoom.s === 1 ? 0 : y;
      clampPan();
      applyZoom(anim !== false);
    }

    function zoomAt(cx, cy, ns, anim) {
      ns = clamp(ns, 1, zoom.max);
      var r = fig.getBoundingClientRect();
      var ccx = r.left + r.width / 2, ccy = r.top + r.height / 2;
      var k = ns / zoom.s;
      var nx = (cx - ccx) * (1 - k) + zoom.x * k;
      var ny = (cy - ccy) * (1 - k) + zoom.y * k;
      setZoom(ns, nx, ny, anim);
    }

    function resetZoom() { zoom.s = 1; zoom.x = 0; zoom.y = 0; applyZoom(false); }

    function bindZoom() {
      var drag = null, moved = 0, pinch = null, lastTap = 0;

      el.addEventListener('wheel', function (e) {
        if (mode !== 'image') return;
        e.preventDefault();
        // Zeigt die Maus neben das Bild, wird auf den nächsten Punkt im Bild gezoomt.
        var r = fig.getBoundingClientRect();
        var cx = clamp(e.clientX, r.left, r.right);
        var cy = clamp(e.clientY, r.top, r.bottom);
        zoomAt(cx, cy, zoom.s * Math.exp(-e.deltaY * 0.0016), false);
      }, { passive: false });

      img.addEventListener('click', function (e) {
        if (mode !== 'image' || moved > 6) return;
        e.stopPropagation();
        if (zoom.s > 1.01) setZoom(1, 0, 0, true);
        else zoomAt(e.clientX, e.clientY, 2.5, true);
      });

      img.addEventListener('pointerdown', function (e) {
        if (mode !== 'image' || e.pointerType === 'touch') return;
        moved = 0;
        if (zoom.s <= 1.01) return;
        drag = { x: e.clientX, y: e.clientY, ox: zoom.x, oy: zoom.y };
        el.classList.add('is-grabbing');
        img.setPointerCapture(e.pointerId);
      });
      img.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        moved = Math.max(moved, Math.abs(dx) + Math.abs(dy));
        zoom.x = drag.ox + dx; zoom.y = drag.oy + dy;
        clampPan();
        applyZoom(false);
      });
      function endDrag() { drag = null; el.classList.remove('is-grabbing'); setTimeout(function () { moved = 0; }, 30); }
      img.addEventListener('pointerup', endDrag);
      img.addEventListener('pointercancel', endDrag);

      el.addEventListener('touchstart', function (e) {
        if (mode !== 'image') return;
        if (e.touches.length === 2) {
          var a = e.touches[0], b = e.touches[1];
          pinch = {
            d: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY),
            s: zoom.s,
            cx: (a.clientX + b.clientX) / 2,
            cy: (a.clientY + b.clientY) / 2
          };
          touch = null;
          return;
        }
        if (e.touches.length !== 1) { touch = null; return; }
        touch = { x: e.touches[0].clientX, y: e.touches[0].clientY, sx: zoom.x, sy: zoom.y, t: Date.now() };
      }, { passive: true });

      el.addEventListener('touchmove', function (e) {
        if (mode !== 'image') return;
        if (pinch && e.touches.length === 2) {
          e.preventDefault();
          var a = e.touches[0], b = e.touches[1];
          var d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          zoomAt(pinch.cx, pinch.cy, pinch.s * (d / pinch.d), false);
          return;
        }
        if (touch && zoom.s > 1.01 && e.touches.length === 1) {
          e.preventDefault();
          zoom.x = touch.sx + (e.touches[0].clientX - touch.x);
          zoom.y = touch.sy + (e.touches[0].clientY - touch.y);
          clampPan();
          applyZoom(false);
        }
      }, { passive: false });

      el.addEventListener('touchend', function (e) {
        if (mode !== 'image') return;
        if (pinch) { pinch = null; if (zoom.s < 1.05) setZoom(1, 0, 0, true); return; }
        if (!touch) return;
        var dx = e.changedTouches[0].clientX - touch.x;
        var dy = e.changedTouches[0].clientY - touch.y;
        var quick = Date.now() - touch.t < 250 && Math.abs(dx) < 12 && Math.abs(dy) < 12;
        var onImage = e.target === img;
        touch = null;
        if (quick && onImage) {
          var now = Date.now();
          if (now - lastTap < 320) {
            lastTap = 0;
            if (zoom.s > 1.01) setZoom(1, 0, 0, true);
            else zoomAt(e.changedTouches[0].clientX, e.changedTouches[0].clientY, 2.5, true);
          } else {
            lastTap = now;
          }
          return;
        }
        if (zoom.s > 1.01) return;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
        else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
      }, { passive: true });
    }

    /* ---------- Miniaturen ---------- */
    var sizedSrc = sizedUrl;

    function buildThumbs() {
      if (!thumbs) return;
      thumbs.innerHTML = '';
      if (mode !== 'image' || items.length < 2) { thumbs.hidden = true; return; }
      thumbs.hidden = false;
      items.forEach(function (it, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bek-pm-lb__thumb';
        b.setAttribute('aria-label', 'Bild ' + (i + 1));
        var im = document.createElement('img');
        im.src = sizedSrc(it.src, 180);
        im.alt = '';
        im.loading = 'lazy';
        im.decoding = 'async';
        b.appendChild(im);
        b.addEventListener('click', function () { goTo(i); });
        thumbs.appendChild(b);
      });
      markThumb();
    }

    function markThumb() {
      if (!thumbs || thumbs.hidden) return;
      [].forEach.call(thumbs.children, function (b, i) {
        var on = i === idx;
        b.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: RM.matches ? 'auto' : 'smooth' });
      });
    }

    function layout(it) {
      var vw = window.innerWidth, vh = window.innerHeight, mob = vw < 590;
      // Das Bild soll im Overlay ruhig stehen und nicht den ganzen Bildschirm ausfüllen.
      // Deshalb bleibt ringsum Luft, und die Bühne ist zusätzlich nach oben begrenzt.
      var padX = mob ? 18 : Math.max(96, Math.round(vw * 0.15));
      var top = mob ? 64 : 84;
      var bottom = mob ? 172 : 184;
      if (items.length < 2) bottom = mob ? 120 : 110;
      var maxW = Math.min(vw - padX * 2, 1180);
      var maxH = Math.min(vh - top - bottom, Math.round(vh * (mob ? 0.68 : 0.7)));
      var w = it.w || 1600, h = it.h || 900;
      var s = Math.min(maxW / w, maxH / h);
      w = Math.round(w * s); h = Math.round(h * s);
      var band = vh - top - bottom;
      return { w: w, h: h, left: Math.round((vw - w) / 2), top: Math.round(top + (band - h) / 2) };
    }

    function place(t) {
      fig.style.left = t.left + 'px';
      fig.style.top = t.top + 'px';
      fig.style.width = t.w + 'px';
      fig.style.height = t.h + 'px';
    }

    function tileImg(i) {
      var it = items[i];
      if (it && it.el && document.contains(it.el)) return it.el;
      if (!root) return null;
      var b = root.querySelector('[data-bek-pm-index="' + i + '"]');
      return b ? b.querySelector('img') : null;
    }

    function inView(r) {
      return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
    }

    /* FLIP: Transform + Clip vom Kachel-Rechteck zum Ziel-Rechteck */
    function flipVars(r, t) {
      var s = Math.max(r.width / t.w, r.height / t.h);
      var dx = (r.left + r.width / 2) - (t.left + t.w / 2);
      var dy = (r.top + r.height / 2) - (t.top + t.h / 2);
      var ix = Math.max(0, (t.w - r.width / s) / 2);
      var iy = Math.max(0, (t.h - r.height / s) / 2);
      return {
        transform: 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + s.toFixed(4) + ')',
        clip: 'inset(' + iy.toFixed(1) + 'px ' + ix.toFixed(1) + 'px round ' + (12 / s).toFixed(1) + 'px)'
      };
    }

    function setImage(it) {
      img.removeAttribute('srcset');
      img.src = it.src;
      img.sizes = '(max-width: 589px) 92vw, 72vw';
      if (it.srcset) img.srcset = it.srcset;
      img.alt = it.alt || '';
      // Bildunterschrift nur, wo der Text dafür gedacht ist. In der Produktgalerie
      // sind die Alt-Texte technische SEO-Beschreibungen und bleiben unsichtbar.
      cap.textContent = it.noCaption ? '' : (it.cap || it.alt || '');
      counter.textContent = (idx + 1) + ' / ' + items.length;
      var multi = items.length > 1;
      prev.hidden = !multi;
      next.hidden = !multi;
      preload(idx + 1);
      preload(idx - 1);
    }

    function preload(i) {
      if (items.length < 2) return;
      var it = items[(i + items.length) % items.length];
      if (!it || it._pre) return;
      it._pre = true;
      var p = new Image();
      p.sizes = '(max-width: 589px) 92vw, 72vw';
      if (it.srcset) p.srcset = it.srcset;
      p.src = it.src;
    }

    function show() {
      el.hidden = false;
      lock(true);
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    }

    function openImage(list, i, trigger, r) {
      build();
      if (!list.length) return;
      cancelClose();
      items = list; idx = Math.max(0, Math.min(list.length - 1, i)); root = r; mode = 'image';
      lastFocus = trigger;
      el.classList.remove('is-video');
      el.setAttribute('aria-label', 'Bildergalerie');
      var it = items[idx];
      resetZoom();
      buildThumbs();
      var t = layout(it);
      place(t);
      var src = tileImg(idx);
      // Sofort das bereits geladene Kachelbild zeigen, dann die große Version nachladen.
      setImage(it);
      if (src && src.currentSrc) { img.removeAttribute('srcset'); img.src = src.currentSrc; if (it.srcset) img.srcset = it.srcset; }
      var rect = src ? src.getBoundingClientRect() : null;
      if (!RM.matches && rect && inView(rect)) {
        var v = flipVars(rect, t);
        img.style.transition = 'none';
        img.style.transform = v.transform;
        img.style.clipPath = v.clip;
        show();
        img.getBoundingClientRect();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            img.style.transition = '';
            img.style.transform = '';
            img.style.clipPath = '';
          });
        });
      } else {
        img.style.transform = ''; img.style.clipPath = '';
        show();
      }
      setTimeout(function () { closeBtn.focus({ preventScroll: true }); }, 30);
    }

    function goTo(i) {
      if (mode !== 'image' || items.length < 2) return;
      i = (i + items.length) % items.length;
      if (i === idx) { if (zoom.s > 1.01) setZoom(1, 0, 0, true); return; }
      idx = i;
      var it = items[idx];
      resetZoom();
      img.classList.add('is-switch');
      setTimeout(function () {
        place(layout(it));
        setImage(it);
        markThumb();
        var reveal = function () { img.classList.remove('is-switch'); };
        if (img.decode) img.decode().then(reveal, reveal); else img.onload = reveal;
      }, RM.matches ? 0 : 160);
    }

    function go(d) { goTo(idx + d); }

    function openVideo(id, trigger) {
      build();
      cancelClose();
      mode = 'video'; lastFocus = trigger; root = null;
      el.classList.add('is-video');
      el.setAttribute('aria-label', 'Video');
      resetZoom();
      if (thumbs) { thumbs.innerHTML = ''; thumbs.hidden = true; }
      var safe = String(id).replace(/[^A-Za-z0-9_-]/g, '');
      vbox.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + safe +
        '?autoplay=1&rel=0&playsinline=1&modestbranding=1" title="Video" ' +
        'allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      show();
      setTimeout(function () { closeBtn.focus({ preventScroll: true }); }, 30);
    }

    function finish() {
      closeTimer = 0;
      el.hidden = true;
      vbox.innerHTML = '';
      resetZoom();
      el.classList.remove('is-zoomed', 'is-grabbing');
      img.style.transition = ''; img.style.transform = ''; img.style.clipPath = '';
      lock(false);
      closing = false;
      restoreFocus();
    }

    /* a11y: Fokus nach dem Schließen (in finish) an den Auslöser zurückgeben.
       Ein Bild als Auslöser ist nicht fokussierbar: dann die Lupe daneben nehmen. */
    function restoreFocus() {
      var t = lastFocus;
      if (!t || !document.contains(t)) return;
      if (t.classList && t.classList.contains('photoswipe__image')) {
        var box = t.closest('.product__photo, [data-index], li, div');
        var zoomBtn = box && box.querySelector('.js-photoswipe__zoom');
        if (zoomBtn) t = zoomBtn;
      }
      if (document.activeElement === t) return;
      if (t.tabIndex < 0 && !t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
      t.focus({ preventScroll: true });
    }

    /* Erneutes Öffnen während der Schließanimation: alten finish()-Timer verwerfen. */
    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = 0; }
      if (closing && img) img.style.opacity = '';
      closing = false;
    }

    function close() {
      if (!el || el.hidden || closing) return;
      closing = true;
      el.classList.remove('is-open');
      var wait = RM.matches ? 200 : 380;
      if (mode === 'image' && zoom.s > 1.01) { resetZoom(); }
      if (mode === 'image' && !RM.matches) {
        var src = tileImg(idx);
        var rect = src ? src.getBoundingClientRect() : null;
        if (rect && inView(rect)) {
          var v = flipVars(rect, layout(items[idx]));
          img.style.transform = v.transform;
          img.style.clipPath = v.clip;
          wait = 520;
        } else {
          img.style.opacity = '0';
          setTimeout(function () { img.style.opacity = ''; }, wait + 20);
        }
      }
      closeTimer = setTimeout(finish, wait);
    }

    return { openImage: openImage, openVideo: openVideo };
  })();

  /* ---------- Init ---------- */
  function init(root) {
    if (root.__bekPm) return;
    root.__bekPm = true;
    root.classList.add('is-js');
    var items = [];
    var dataEl = root.querySelector('[data-bek-pm-data]');
    try { items = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch (e) { items = []; }
    reveal(root);
    tilt(root);
    dots(root);
    arrows(root);
    root.addEventListener('click', function (e) {
      var v = e.target.closest('[data-bek-pm-video]');
      if (v && root.contains(v)) {
        e.preventDefault();
        var btn = root.querySelector('.bek-pm-vcard__button') || v;
        LB.openVideo(v.getAttribute('data-bek-pm-video'), btn);
        return;
      }
      var t = e.target.closest('[data-bek-pm-index]');
      if (t && root.contains(t) && items.length) {
        e.preventDefault();
        LB.openImage(items, parseInt(t.getAttribute('data-bek-pm-index'), 10) || 0, t, root);
      }
    });
  }

  /* ---------- Produktgalerie: die Lupe öffnet dieselbe Lightbox wie die Medien-Sektion ---------- */
  function galleryItems() {
    var out = [], seen = {};
    [].forEach.call(document.querySelectorAll('.photoswipe__image'), function (im) {
      var raw = im.getAttribute('data-photoswipe-src') || im.currentSrc || im.getAttribute('src') || '';
      if (!raw) return;
      if (raw.indexOf('//') === 0) raw = window.location.protocol + raw;
      var key = raw.split('?')[0];
      if (seen[key]) return;
      seen[key] = true;
      var w = parseInt(im.getAttribute('data-photoswipe-width'), 10) || im.naturalWidth || 2000;
      var h = parseInt(im.getAttribute('data-photoswipe-height'), 10) || im.naturalHeight || 2000;
      var set = [];
      [600, 900, 1200, 1600, 2000, 2600, 3200].forEach(function (n) {
        if (n <= w * 1.25) set.push(sizedUrl(raw, n) + ' ' + n + 'w');
      });
      out.push({
        src: sizedUrl(raw, 1600),
        srcset: set.join(', '),
        w: w, h: h,
        alt: im.getAttribute('alt') || '',
        noCaption: true,
        el: im,
        key: key
      });
    });
    return out;
  }

  function galleryIndex(trigger, list) {
    var im = trigger.classList && trigger.classList.contains('photoswipe__image') ? trigger : null;
    if (!im) {
      var box = trigger.closest('[data-index], .product__photo, li, div');
      if (box) im = box.querySelector('.photoswipe__image');
    }
    if (!im) {
      // Fallback: das Bild mit der größten sichtbaren Fläche
      var best = null, bestArea = 0;
      [].forEach.call(document.querySelectorAll('.photoswipe__image'), function (c) {
        var r = c.getBoundingClientRect();
        var vis = Math.max(0, Math.min(r.right, window.innerWidth) - Math.max(r.left, 0)) *
          Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
        if (vis > bestArea) { bestArea = vis; best = c; }
      });
      im = best;
    }
    if (!im) return 0;
    var raw = im.getAttribute('data-photoswipe-src') || im.currentSrc || im.getAttribute('src') || '';
    if (raw.indexOf('//') === 0) raw = window.location.protocol + raw;
    var key = raw.split('?')[0];
    for (var i = 0; i < list.length; i++) { if (list[i].key === key) { list[i].el = im; return i; } }
    return 0;
  }

  function bindGallery() {
    if (!window.bekGalleryZoom) return;
    if (!document.querySelector('.photoswipe__image')) return;
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.js-photoswipe__zoom, .photoswipe__image') : null;
      if (!t) return;
      var list = galleryItems();
      if (!list.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      LB.openImage(list, galleryIndex(t, list), t, null);
    }, true);
  }

  function boot() {
    document.querySelectorAll('[data-bek-pm]').forEach(init);
    bindGallery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('bek:reduce-motion', function (e) {
    if (e.detail && e.detail.on === false) document.querySelectorAll('[data-bek-pm]').forEach(function (r) { if (r.__bekPm) tilt(r); });
  });
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-bek-pm]');
    if (r) init(r);
  });
})();
